<div class="pill">
	<div class="value">{{ value }}</div>
</div>
